import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {customAxios} from "../functions/custom_axios";
import {s2ab} from '../../../_services/essentials/functions';
import saveAs from 'file-saver'

const name = 'master_profile';
const entity = 'master_profile';
const entities = 'master_profiles';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });



export const masterProfilesActions = { ...slice.actions, ...extraActions };
export const masterProfilesReducer = slice.reducer;



function createInitialState() {
    return {
        list: null,
        item: null,
        listAPIResponse: null,
        education_qualifications: null,
        professional_activities: null,
        honor_and_awards: null,
        press: null,
        publication: null,
        chart_pub_data: null,
    }
}

function createExtraActions() {


    return {
        getAll: getAll(),
        getById: getById(),
        create: create(),
        update: update(),
        delete: _delete(),
        getPaginatedList: getPaginatedList(),
        getEducationQualificationsByFilter: getEducationQualificationsByFilter(),
        getProfessionalActivitiesByFilter: getProfessionalActivitiesByFilter(),
        getHonorAndAwardsByFilter: getHonorAndAwardsByFilter(),
        getPressByFilter: getPressByFilter(),
        getPublicationByFilter: getPublicationByFilter(),
        downloadprofilesByFilter: downloadprofilesByFilter(),
        getChartPubData: getChartPubData(),
        getChartEventData: getChartEventData(),
        getChartClinicalTrialData: getChartClinicalTrialData(),
        getChartSocialMediaData: getChartSocialMediaData(),
        getKeywordMetricsData: getKeywordMetricsData(),
        getSocialMediaAccounts: getSocialMediaAccounts()
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async function ({ getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };

                    const response = await customAxios.get(`/api/${entities}`,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getById() {
        return createAsyncThunk(
            `${name}/getById`,
            async function (id, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/${entity}/${id}`,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function create() {
        return createAsyncThunk(
            `${name}/create`,
            async function ({ data }, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/${entity}`, data,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function update() {
        return createAsyncThunk(
            `${name}/update`,
            async function ({ id, data }, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.put(`/api/${entity}/${id}`, data,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    // prefixed with underscore because delete is a reserved word in javascript
    function _delete() {
        return createAsyncThunk(
            `${name}/delete`,
            async function (id, { getState, dispatch }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.delete(`/api/${entity}/${id}`, {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function getPaginatedList() {
        return createAsyncThunk(
            `${name}/getPaginatedList`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/${entities}`, filter, {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function getEducationQualificationsByFilter() {
        return createAsyncThunk(
            `${name}/getEducationQualificationsByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/education_qualifications`, filter,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getProfessionalActivitiesByFilter() {
        return createAsyncThunk(
            `${name}/getProfessionalActivitiesByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/professional_activities`, filter,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getHonorAndAwardsByFilter() {
        return createAsyncThunk(
            `${name}/getHonorAndAwardsByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/honor_and_awards`, filter,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getPressByFilter() {
        return createAsyncThunk(
            `${name}/getPressByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/press`, filter,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getPublicationByFilter() {
        return createAsyncThunk(
            `${name}/getPublicationByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/publication`, filter,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }

        );
    }

    function downloadprofilesByFilter() {
        return createAsyncThunk(
            `${name}/downloadprofilesByFilter`,
            async function (filter, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`/api/customized/master_profiles/export/excel`, filter,  {headers});
                    const responseData = response.data;

                    if(responseData) {
                        const projectName = filter.projectName ? `- ${filter.projectName}` : ``;
                        const currentDateTime = new Date();
                        const formattedCurrentDateTime = `${currentDateTime.getFullYear()}-${currentDateTime.getMonth()}-${currentDateTime.getDate()} ${currentDateTime.getHours()}-${currentDateTime.getMinutes()}-${currentDateTime.getSeconds()}`;
                        const fileName = `Profiles ${projectName} - ${formattedCurrentDateTime}.xlsx`;

                        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;';
                        const blob = new Blob([s2ab(atob(response.data))], {type: fileType});
                        saveAs(blob, fileName);
                        return true;
                    } else {
                        return 'Error occured. Please try again later.';
                    }

                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getChartPubData() {
        return createAsyncThunk(
            `${name}/getChartPubData`,
            async function ({id, chart_limit}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/chart_data/master_profile/publication/${id}/${chart_limit}`, {headers});
                    const responseData = response.data;
                    return responseData;

                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getChartEventData() {
        return createAsyncThunk(
            `${name}/getChartEventData`,
            async function ({id, chart_limit}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/chart_data/master_profile/event/${id}/${chart_limit}`, {headers});
                    const responseData = response.data;
                    return responseData;

                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getChartClinicalTrialData() {
        return createAsyncThunk(
            `${name}/getChartClinicalTrialData`,
            async function ({id, chart_limit}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/chart_data/master_profile/clinical_trial/${id}/${chart_limit}`, {headers});
                    const responseData = response.data;
                    return responseData;

                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getChartSocialMediaData() {
        return createAsyncThunk(
            `${name}/getChartSocialMediaData`,
            async function ({id, chart_limit}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/chart_data/master_profile/social_media/${id}/${chart_limit}`, {headers});
                    const responseData = response.data;
                    return responseData;

                } catch (error) {
                    return null;
                }
            }

        );
    }

    function getKeywordMetricsData() {
        return createAsyncThunk(
            `${name}/getKeywordMetricsData`,
            async function ({id}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/word_cloud/master_profile/keyword_metrics/${id}`, {headers});
                    const responseData = response.data;
                    //console.log('responseData: '+ JSON.stringify(responseData));
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

    function getSocialMediaAccounts() {
        return createAsyncThunk(
            `${name}/getSocialMediaAccounts`,
            async function ({id}, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`/api/social_media_account_by_profile_id/${id}`, {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return []
                }
            }
        );
    }

}

function createExtraReducers() {
    return (builder) => {
        getAll();
        getById();
        update();
        _delete();
        getPaginatedList();
        getEducationQualificationsByFilter();
        getProfessionalActivitiesByFilter();
        getHonorAndAwardsByFilter();
        getPressByFilter();
        getPublicationByFilter();

        function getAll() {
            var { pending, fulfilled, rejected } = extraActions.getAll;
            builder
                .addCase(pending, (state) => {
                    state.list = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.list = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.list = { error: action.error };
                });
        }

        function getById() {
            var { pending, fulfilled, rejected } = extraActions.getById;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        function update() {
            var { pending, fulfilled, rejected } = extraActions.update;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        function _delete() {
            var { pending, fulfilled, rejected } = extraActions.delete;
            builder
                .addCase(pending, (state, action) => {
                    const user = state.list.value.find(x => x.id === action.meta.arg);
                    user.isDeleting = true;
                })
                .addCase(fulfilled, (state, action) => {
                    state.list.value = state.list.value.filter(x => x.id !== action.meta.arg);
                })
                .addCase(rejected, (state, action) => {
                    const user = state.list.value.find(x => x.id === action.meta.arg);
                    user.isDeleting = false;
                });
        }

        function getPaginatedList() {
            var { pending, fulfilled, rejected } = extraActions.getPaginatedList;
            builder
                .addCase(pending, (state) => {
                    state.listAPIResponse = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.listAPIResponse = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.listAPIResponse = { error: action.error };
                });
        }

        function getEducationQualificationsByFilter() {
            var { pending, fulfilled, rejected } = extraActions.getEducationQualificationsByFilter;
            builder
                .addCase(pending, (state) => {
                    state.education_qualifications = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.education_qualifications = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.education_qualifications = { error: action.error };
                });
        }

        function getProfessionalActivitiesByFilter() {
            var { pending, fulfilled, rejected } = extraActions.getProfessionalActivitiesByFilter;
            builder
                .addCase(pending, (state) => {
                    state.professional_activities = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.professional_activities = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.professional_activities = { error: action.error };
                });
        }

        function getHonorAndAwardsByFilter() {
            var { pending, fulfilled, rejected } = extraActions.getHonorAndAwardsByFilter;
            builder
                .addCase(pending, (state) => {
                    state.honor_and_awards = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.honor_and_awards = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.honor_and_awards = { error: action.error };
                });
        }

        function getPressByFilter() {
            var { pending, fulfilled, rejected } = extraActions.getPressByFilter;
            builder
                .addCase(pending, (state) => {
                    state.press = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.press = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.press = { error: action.error };
                });
        }

        function getPublicationByFilter() {
            var { pending, fulfilled, rejected } = extraActions.getPublicationByFilter;
            builder
                .addCase(pending, (state) => {
                    state.publication = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.publication = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.publication = { error: action.error };
                });
        }

    };
}